import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {SvgIconComponent} from "../svg-icon/svg-icon.component";

@Component({
  selector: 'app-navigation-box',
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    SvgIconComponent,
    NgClass
  ],
  templateUrl: './navigation-box.component.html',
  styleUrl: './navigation-box.component.scss'
})
export class NavigationBoxComponent {
  @Input() withIcon: boolean = true;
  @Input() rightText: string = "";
  @Input() rightIsActive: boolean = true;
  @Input() leftIsActive: boolean = true;
  @Input() leftIsVisible: boolean = true;
  @Output() leftIsPressed: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() rightIsPressed: EventEmitter<boolean> = new EventEmitter<boolean>();

  protected leftPressed(): void {
    this.leftIsPressed.emit(true);
  }

  protected rightPressed(): void {
    this.rightIsPressed.emit(true);
  }
}
